import { State as RootState } from "@/store";
import { GetterTree } from "vuex";
import { State as LocalState } from "./state";

// Getters types
export type Getters = {
  getIsTrackingAvailable(): boolean;
};

// Getters
export const getters: GetterTree<LocalState, RootState> & Getters = {
  getIsTrackingAvailable: () => {
    return !!process.env.VUE_APP_ANALYTICS_ID;
  },
};
